import { render } from "./CreateWorld.vue?vue&type=template&id=12c5d594"
import script from "./CreateWorld.vue?vue&type=script&lang=js"
export * from "./CreateWorld.vue?vue&type=script&lang=js"
script.render = render

export default script